import { getTypes, default as types } from 'store/types'

const actionType = types?.ACTION_TYPES?.FETCHING
const baseType = types?.BASE_TYPES?.LMS
const lmsTypes = getTypes(actionType, baseType)

export default {
  ...lmsTypes,
}
